import { useQuery } from "@/api/swr/useQuery";
import { evaluationReportSchema } from "@/schema/console/evaluation-reports/EvaluationReport";

type Config = Parameters<typeof useQuery<typeof evaluationReportSchema>>[2];

export function useGetEvaluationReport(id: string, config?: Config) {
  return useQuery(
    evaluationReportSchema,
    `/console/evaluation_reports/${id}`,
    config,
  );
}
